/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronsUp = createReactComponent("chevrons-up", "IconChevronsUp", [
  ["path", { d: "M7 11l5 -5l5 5", key: "svg-0" }],
  ["path", { d: "M7 17l5 -5l5 5", key: "svg-1" }]
]);

export { IconChevronsUp as default };
//# sourceMappingURL=IconChevronsUp.js.map
